import { AlertColor } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

export type SnackbarProps = {
  pinned?: boolean;
  category?: AlertColor;
};

export const useSnackbarStyles = makeStyles((theme) => ({
  snackBar: {
    left: ({ pinned }: { pinned?: boolean }) => (pinned ? 245 : 90),
    flexDirection: 'column',
    alignItems: 'flex-start',
    bottom: 20
  },
  item: {
    minWidth: theme.spacing(37.5),
    fontWeight: 'bold'
  },
  severity: ({ category = 'success' }: SnackbarProps) => {
    switch (category) {
      case 'info':
        return {
          color: theme.palette.info.dark,
          backgroundColor: theme.palette.info.light,
          boxShadow: theme.shadow?.paper
        };
      case 'warning':
        return {
          color: theme.palette.warning.dark,
          backgroundColor: theme.palette.warning.light,
          boxShadow: theme.shadow?.paper
        };
      case 'error':
        return {
          color: theme.palette.error.dark,
          backgroundColor: theme.palette.error.light,
          boxShadow: theme.shadow?.paper
        };
      default:
        return {
          color: theme.palette.success.dark,
          backgroundColor: theme.palette.success.light,
          boxShadow: theme.shadow?.paper
        };
    }
  }
}));
